export const IS_MOCKED = process.env.REACT_APP_DATA_SOURCE === 'MOCKED';
